// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"78":"30c060bc","651":"30c060bc"}[chunkId] + ".chunk.css");